import { ChangeDetectionStrategy, Component, HostBinding, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { CoreUiInteractionEvent, UiInteraction } from "@obg/ngx.core";
import { CoreContentState, Flag, FlagSelector } from "@obg/ngx.core.content";
import { Observable, Subscription } from "rxjs";
import { filter } from "rxjs/operators";

import { HeaderAction, TrackingContext } from "../header/tracking.model";

import { ExtendedFlag } from "./language-selector.model";

const languageEvent: UiInteraction = {
	event: CoreUiInteractionEvent.Navigate,
	context: TrackingContext.HeaderInteractionContext,
};

@Component({
	selector: "obg-m-language-selector-container",
	templateUrl: "./language-selector.container.html",
	styleUrls: ["./language-selector.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class LanguageSelectorContainer implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-language-selector") hostCssClass = true;

	currentMarket$: Observable<Flag | undefined> | undefined;
	flags: ExtendedFlag[] = [];
	languageTrackingData: UiInteraction = { ...languageEvent, data: { ItemClicked: HeaderAction.Language } };
	private flags$$: Subscription | undefined;

	constructor(private store: Store<CoreContentState>) {}

	ngOnInit() {
		this.currentMarket$ = this.store.select(FlagSelector.getCurrentFlag);
		this.flags$$ = this.store
			.select(FlagSelector.getAll)
			.pipe(filter((flags) => !!flags))
			.subscribe((flags) => {
				this.flags = flags.map((flag) => ({
					...flag,
					uiInteractionEvent: {
						...languageEvent,
						data: {
							ItemClicked: flag ? `Language - ${flag.languageCode}-${flag.countryCode}` : "Language",
						},
					},
				}));
			});
	}

	ngOnDestroy() {
		this.flags$$?.unsubscribe();
	}
}
